/**
 * Copy of https://github.com/mapbox/react-range without React as
 * a dependency. Licence included below.
 *
 * ISC License
 *
 * Copyright (c) 2015, Mapbox
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

import React from 'react';

export default class Range extends React.Component {
  constructor(props) {
    super(props);

    this.onRangeClick = this.onRangeClick.bind(this);
    this.onRangeKeyDown = this.onRangeKeyDown.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
    this.onRangeInput = this.onRangeInput.bind(this);
  }

  input = null;

  fireChange(e) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(e);
    }
  }

  onRangeChange(e) {
    if (typeof this.props.onMouseMove === 'function') {
      this.props.onMouseMove(e);
    }
    if (e.buttons !== 1 && e.which !== 1) return;
    this.fireChange(e);
  }

  onRangeClick(e) {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick(e);
    }
    this.fireChange(e);
  }

  onRangeKeyDown(e) {
    if (typeof this.props.onKeyDown === 'function') {
      this.props.onKeyDown(e);
    }
    this.fireChange(e);
  }

  onRangeInput(e) {
    if (typeof this.props.onInput === 'function') {
      this.props.onInput(e);
    }
    this.fireChange(e);
  }

  componentWillReceiveProps(props) {
    this.input.value = props.value;
  }

  render() {
    let { value, ...props } = this.props;
    return (
      <input
        {...props}
        type='range'
        ref={input => {this.input = input;}}
        defaultValue={value}
        onClick={this.onRangeClick}
        onKeyDown={this.onRangeKeyDown}
        onMouseMove={this.onRangeChange}
        onInput={this.onRangeInput}
        onChange={() => {}}/>
    );
  }
}
